import { Injectable } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';
import { AlertsService } from 'src/modules/base/services/alerts.service';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(
    private baseService: BaseService,
    public smartModalService: SmartModalService,
    public alertsService:AlertsService

  ) { }

  getServiceFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "duplicate_class":true,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Appointment date Time",
        "selected": true,
        "hidden": false,
        "type": "date",
        "name": "appointment_time",
        "order": 2
      },
      //  {
      //   "heading": "Renewal date Time",
      //   "selected": true,
      //   "hidden": false,
      //   "type": "date",
      //   "name": "renewal_date",
      //   "order": 3
      // },
    {
        "heading": "Renewal date",
        "selected": true,
        "hidden": false,
       "type": "calender",
        "name": "renewal_date",
        "cryoOnly": true,
        "order": 3
      },
      {
        "type": "inputSearch",
        "name": "performing_doctor",
        "order": 4,
        "hide": false,
        "heading": "Perform By",
        searchDoctorArgsForProcedure: {
          "complex_search": [
            {
              "label": "field.label.doctor",
              "key": "display_name",
            },

            {
              "label": "field.label.speciality",
              "key": "speciality"
            },
            {
              "label": "field.label.doctor_code",
              "key": "doctor_code"
            }
          ],

          "datasource": {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "key": "practitioner_id",
            "getterValue": "display_name",
            "query_id": "GET_DOCTOR_BY_FILTER",
            "order_by": "display_name",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!!"
          },
          "capitalise": true,
          "fields": ["display_name", "speciality"]
        }
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Service Item",
        "name": "serviceItemName",
        "selected": true,
        "duplicate_class":true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Department Name",
        "name": "department_name",
        "selected": true,
        "duplicate_class":true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Sub Department Name",
        "name": "subDepartment_name",
        "selected": true,
        "duplicate_class":true,
        "hidden": false,
        "order": 7
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Order Id",
        "name": "orderId",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Confirm Order",
        "name": "confirm_order",
        "selected": true,
        "format": "fn=function(item){ return (item.confirm_order == true || item.confirm_order == 'true')?'Yes':'No'}",
        "hidden": false,
        "order": 10
      },
       {
        "heading": "field.label.price",
        "name": "pricePerItem",
        "selected": true,
        "hidden": false,
        "order": 11,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 11,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 12,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "hidden": false,
        "typeValue": "decimal_currency",
        "hint": "Enter discount",
        "disable": true,
        "order": 13
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 14,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 15,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 16
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 17
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 18
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 19
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 20
      },
      {
        "heading": "CPOE REMARK",
        "name": "nurse_remark",
        "selected": true,
        "hidden": false,
        "order": 21
      },
      {
        "heading": "f.l.p_ins",
        "name": "patient_instructions",
        "selected": true,
        "hidden": false,
        "order": 22
      },
      {
        "heading": "field.label.outsource",
        "name": "is_outsource",
        "selected": true,
        "hidden": false,
        "order": 23,
        "format": "fn=function(item){return (item.is_outsource == true) ? 'Yes' : 'No';}",
        "type": "composite"
      },
      {
        "heading": "field.label.standard_code",
        "selected": true,
        "hidden": false,
        "order": 24,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "Tat Time Duration",
        "name": "tat_time_duration_display",
        "selected": true,
        "hidden": false,
        "order": 25
      },
      {
        "heading": "field.label.band_type",
        "name": "band_type_name",
        "type": "string",
        "selected": true,
        "hidden": true,
        "order": 26
      },
      // {
      //   "heading": "Renewal date Time",
      //   "selected": true,
      //   "hidden": false,
      //   "type": "date",
      //   "name": "renewal_date",
      //   "order": 26
      // },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 27,
        "array": [
          {
            "delete": false,
            "cancel": true,
            "toolTip": "Cancel Service",
            "cancel-icon": "fa fa-times",
            "edit": false
          },
          {
            "delete": false,
            "cancel": false,
            "print": true,
            "toolTip": "print",
            "cancel-icon": "fa fa-times",
            "edit": false,
            "isUserPrint": true,
            "file_data": {
              "application": "facility-management",
              "template": "phcpackagedetailsbills",
              "resource": "phc_detail",
              "query_id": "GET_ALL",
              "args": "id:!!!id!!!,reportTemplateId:phcpackagedetailsbills",
              "filter": "phc_id:!!!serviceItemId!!!",
              "file_type": "pdf",
              "contentType": "pdf",
            },
            "resetDataSource": {
              "application": "facility-management",
              "template": "phcpackagedetailsbills",
              "resource": "phc_detail",
              "query_id": "GET_ALL",
              "args": "id:!!!id!!!,reportTemplateId:phcpackagedetailsbills",
              "filter": "phc_id:!!!serviceItemId!!!",
              "file_type": "pdf",
              "contentType": "pdf",
            },
            "condition": "item['serviceType_code'] == 'phc' && !item['miscllaneous']"
          },
          {
            "delete": false,
            "edit": true,
            "toolTip": "View Detail",
            "edit-icon": "fa fa-info",
            "condition": "(item['serviceType_code'] == 'phc' || item['serviceType_code'] == 'pathology'  || item['serviceType_code'] == 'care_plan')  && !item['miscllaneous']"
          },
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "emitValue": true,
            "splitValue": true,
            "edit": false,
            "condition": "item['serviceType_code'] != 'pharmacy' || item['miscllaneous']"
          }
        ]
      }
    ];
    return fields;
  }
  getSerCompFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Service Name",
        "selected": true,
        "hidden": false,
        "name": "serviceItemName",
        "order": 1
      },
      {
        "heading": "Amount",
        "type": "editConfig_textbox",
        "name": "price",
        "selected": true,
        "hidden": false,
        "typeValue": "decimal_currency",
        "hint": "Enter Amount",
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ],
        "order": 2
      },
      {
        "heading": "Quantity",
        "type": "condition_tb",
        "name": "qty",
        "disable": false,
        "hide": true,
        "typeValue": "decimal_currency",
        "hint": "Enter Quantity",
        "order": 2
      },
      {
        "heading": "Appointment date Time",
        "selected": true,
        "hidden": false,
        "type": "calender",
        "name": "appointment_time",
        "order": 2
       },
      //  {
      //   "heading": "Renewal date",
      //   "selected": false,
      //   "hidden": false,
      //  "type": "calender",
      //   "name": "renewal_date",
      //   "order": 3
      // },
      
      {
        "heading": "Priority",
        "selected": true,
        "hidden": false,
        "disable": false,
        "type": "dropdown",
        "key": "service_priority_id",
        "data": "dropDownData",
        "name": "priorityCode",
        "defaultKey": "Select Priority",
        "bindKey": "fullName",
        "order": 2
      },
      {
        "type": "inputSearch",
        "name": "serviceDoctor",
        "order": 5,
        "hide": true,
        "heading": "Perform By",
        searchDoctorArgsForProcedure: {
          "complex_search": [
            {
              "label": "field.label.doctor",
              "key": "display_name",
            },

            {
              "label": "field.label.speciality",
              "key": "speciality"
            },
            {
              "label": "field.label.doctor_code",
              "key": "doctor_code"
            }
          ],

          "datasource": {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "key": "practitioner_id",
            "getterValue": "display_name",
            "query_id": "GET_DOCTOR_BY_FILTER",
            "order_by": "display_name",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!!"
          },
          "capitalise": true,
          "fields": ["display_name", "speciality"]
        }
      },
      {
        "heading": "Speciality",
        "selected": true,
        "hidden": false,
        "hide": true,
        "key": "specialityCode",
        "type": "dropdown",
        "data": "specialityData",
        "disable": true,
        "isDependent": true,
        "name": "specialityCode",
        "defaultKey": "Select Speciality",
        "bindKey": "speciality",
        "order": 5
      },
      {
        "heading": "In-source",
        "hidden": false,
        "type": "checkbox",
        "name": "insource_test",
        "order": 5
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 25,
        "array": [
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "emitValue": false,
            "edit": false
          }
        ]
      }
    ]
    return fields;
  }

  getServiceFieldsForEditBill() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Appointment date Time",
        "selected": true,
        "hidden": false,
        "type": "date",
        "name": "appointment_time",
        "order": 2
      },
       {
        "heading": "Renewal date Time",
        "selected": true,
        "hidden": false,
        "type": "date",
        "name": "renewal_date",
        "order": 3
      },
      {
        "type": "inputSearch",
        "name": "performing_doctor",
        "order": 3,
        "hide": false,
        "heading": "Perform By",
        searchDoctorArgsForProcedure: {
          "complex_search": [
            {
              "label": "field.label.doctor",
              "key": "display_name",
            },

            {
              "label": "field.label.speciality",
              "key": "speciality"
            },
            {
              "label": "field.label.doctor_code",
              "key": "doctor_code"
            }
          ],

          "datasource": {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "key": "practitioner_id",
            "getterValue": "display_name",
            "query_id": "GET_DOCTOR_BY_FILTER",
            "order_by": "display_name",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!!"
          },
          "capitalise": true,
          "fields": ["display_name", "speciality"]
        }
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Service Item",
        "name": "serviceName",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Order Id",
        "name": "orderId",
        "selected": true,
        "hidden": false,
        "order": 7
      },
      {
        "heading": "Confirm Order",
        "name": "confirm_order",
        "selected": true,
        "format": "fn=function(item){ return (item.confirm_order == true || item.confirm_order == 'true')?'Yes':'No'}",
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "hidden": false,
        "typeValue": "decimal_currency",
        "hint": "Enter discount",
        "disable": true,
        "order": 11
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 12
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 13
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 14
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 15
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 16
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 17
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 18
      },
      {
        "heading": "CPOE REMARK",
        "name": "nurse_remark",
        "selected": true,
        "hidden": false,
        "order": 19
      },
      {
        "heading": "f.l.p_ins",
        "name": "patient_instructions",
        "selected": true,
        "hidden": false,
        "order": 20
      },
      {
        "heading": "field.label.outsource",
        "name": "is_outsource",
        "selected": true,
        "hidden": false,
        "order": 21,
        "format": "fn=function(item){return (item.is_outsource == true) ? 'Yes' : 'No';}",
        "type": "composite"
      },
      {
        "heading": "field.label.standard_code",
        "card_tag": null,
        "order": 22,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 23,
        "array": [
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "edit": false
          },
          {
            "delete": false,
            "edit": true,
            "toolTip": "View Detail",
            "edit-icon": "fa fa-info",
            "condition": "item['serviceType_code'] == 'phc' && !item['miscllaneous']"
          }
        ]
      }
    ];
    return fields;
  }

  getServiceFieldsForadvanceclinical() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Service Item",
        "name": "serviceName",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Priority",
        "name": "servicePriority",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Order Id",
        "name": "orderId",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Total Amount",
        "name": "totalAmount",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Patient Amount",
        "name": "patientAmount",
        "selected": true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Net Amount",
        "name": "service_bill_amount",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Service Code",
        "name": "serviceCode",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 26,
        "array": [
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "emitValue": true,
            "splitValue": true
          }
        ]
      }
    ];
    return fields;
  }

  getViewServiceFieldsForEditBill() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Appointment date Time",
        "selected": true,
        "hidden": false,
        "type": "date",
        "name": "appointment_time",
        "order": 2
      },
       {
        "heading": "Renewal date Time",
        "selected": true,
        "hidden": false,
        "type": "date",
        "name": "renewal_date",
        "order": 3
      },
      {
        "type": "inputSearch",
        "name": "performing_doctor",
        "order": 3,
        "hide": false,
        "heading": "Perform By",
        searchDoctorArgsForProcedure: {
          "complex_search": [
            {
              "label": "field.label.doctor",
              "key": "display_name",
            },

            {
              "label": "field.label.speciality",
              "key": "speciality"
            },
            {
              "label": "field.label.doctor_code",
              "key": "doctor_code"
            }
          ],

          "datasource": {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "key": "practitioner_id",
            "getterValue": "display_name",
            "query_id": "GET_DOCTOR_BY_FILTER",
            "order_by": "display_name",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!!"
          },
          "capitalise": true,
          "fields": ["display_name", "speciality"]
        }
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Service Item",
        "name": "serviceItemName",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Order Id",
        "name": "orderId",
        "selected": true,
        "hidden": false,
        "order": 7
      },
      {
        "heading": "Confirm Order",
        "name": "confirm_order",
        "selected": true,
        "format": "fn=function(item){ return (item.confirm_order == true || item.confirm_order == 'true')?'Yes':'No'}",
        "hidden": false,
        "order": 8
      },
        {
        "heading": "field.label.price",
        "name": "pricePerItem",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "hidden": false,
        "typeValue": "decimal_currency",
        "hint": "Enter discount",
        "disable": true,
        "order": 11
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 12
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 13
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 14
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 15
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 16
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 17
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 18
      },
      {
        "heading": "CPOE REMARK",
        "name": "nurse_remark",
        "selected": true,
        "hidden": false,
        "order": 19
      },
      {
        "heading": "f.l.p_ins",
        "name": "patient_instructions",
        "selected": true,
        "hidden": false,
        "order": 20
      },
      {
        "heading": "field.label.outsource",
        "name": "is_outsource",
        "selected": true,
        "hidden": false,
        "order": 21,
        "format": "fn=function(item){return (item.is_outsource == true) ? 'Yes' : 'No';}",
        "type": "composite"
      },
      {
        "heading": "field.label.standard_code",
        "card_tag": null,
        "order": 22,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 23,
        "array": [
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "condition": "item['serviceRequestId']==undefined || item['serviceRequestId'] == ''",
            "edit": false
          },
          {
            "delete": false,
            "edit": true,
            "toolTip": "View Detail",
            "edit-icon": "fa fa-info",
            "condition": "item['serviceType_code'] == 'phc' && !item['miscllaneous']"
          }
        ]
      }
    ];
    return fields;
  }

  getServiceApproveFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Performing Doctor",
        "name": "performing_doctor",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 3
      },
      {
        "heading": "Service Item",
        "name": "serviceItemName",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Department Name",
        "name": "department_name",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Sub Department Name",
        "name": "subDepartment_name",
        "selected": true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 7
      },
      {
        "heading": "Order Id",
        "name": "orderId",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Confirm Order",
        "name": "confirm_order",
        "selected": true,
        "format": "fn=function(item){ return (item.confirm_order == true || item.confirm_order == 'true')?'Yes':'No'}",
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 10,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 11,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "hidden": false,
        "hint": "Enter discount",
        "disable": true,
        "order": 12
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 13,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 14,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 15
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 16
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 17
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 18
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 19
      },
      {
        "heading": "Ordering Doctor Name",
        "name": "ordering_doctor_name",
        "selected": true,
        "hidden": false,
        "order": 20
      },
      {
        "heading": "CPOE REMARK",
        "name": "nurse_remark",
        "selected": true,
        "hidden": false,
        "order": 21
      },
      {
        "heading": "f.l.p_ins",
        "name": "patient_instructions",
        "selected": true,
        "hidden": false,
        "order": 22
      },
      {
        "heading": "field.label.outsource",
        "name": "isOutsourced",
        "selected": true,
        "hidden": false,
        "order": 23,
        "format": "fn=function(item){return (item.isOutsourced == true) ? 'Yes' : 'No';}",
        "type": "composite"
      },
      {
        "heading": "field.label.standard_code",
        "card_tag": null,
        "order": 24,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "",
        "type": "mltiple_action",
        "setting": true,
        "order": 25,
        "array": [

        ]
      }
    ];
    return fields;
  }

  getViewFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Performing Doctor",
        "name": "performing_doctor",
        "order": 2
      },
      {
        "heading": "Service Item",
        "name": "serviceName",
        "order": 2
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "order": 4
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "order": 5
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "order": 6
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "order": 7
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "order": 8
      }
    ];
    return fields;
  }

  getFailedItemsFields() {
    const fields: Array<any> = [
      {
        "heading": "field.label.service_item_name",
        "card_tag": null,
        "order": 1,
        "sortable": true,
        "name": "serviceItemName"
      },
      {
        "heading": "field.label.error_desc",
        "card_tag": null,
        "order": 2,
        "sortable": true,
        "name": "failed_items_message"
      }
    ];
    return fields;
  }

  getIpServiceFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Perform By",
        "name": "performing_doctor",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Item",
        "name": "serviceName",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 5,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "typeValue": "decimal_currency",
        "hidden": false,
        "hint": "Enter discount",
        "disable": true,
        "order": 6
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 6,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 7,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 8,
        "grid_color_text": true,
        "class_conditions": [
          {
            "expression": "item['tariff_dependency']=='Yes'",
            "class": "blue-color-text"
          }
        ]
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "field.label.standard_code",
        "card_tag": null,
        "order": 12,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 13,
        "array": [
          {
            "delete": false,
            "edit": true,
            "toolTip": "View Detail",
            "edit-icon": "fa fa-info",
            "condition": "item['serviceType_code'] == 'phc' && !item['miscllaneous']"
          },
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "edit": false,
            "condition": "item['serviceType_code'] != 'pharmacy' || item['miscllaneous']"
          }
        ]
      }
    ];
    return fields;
  }

  getEMRIpServiceFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Perform By",
        "name": "performing_doctor",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Item",
        "name": "serviceName",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "typeValue": "decimal_currency",
        "hidden": false,
        "hint": "Enter discount",
        "disable": true,
        "order": 6
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 7
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "field.label.standard_code",
        "card_tag": null,
        "order": 12,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 13,
        "array": [
          {
            "delete": false,
            "edit": true,
            "toolTip": "View Detail",
            "edit-icon": "fa fa-info",
            "condition": "item['serviceType_code'] == 'phc' && !item['miscllaneous']"
          },
          {
            "type": "action",
            "delete": true,
            "toolTip": "Remove Service",
            "emitValue": true,
            "splitValue": true,
            "edit": false,
            "condition": "item['serviceType_code'] != 'pharmacy' || item['miscllaneous']"
          }
        ]
      }
    ];
    return fields;
  }

  getIpApproveServiceFields() {
    const fields: Array<any> = [
      {
        "heading": "Service Type",
        "selected": true,
        "hidden": false,
        "name": "serviceType",
        "order": 1
      },
      {
        "heading": "Perform By",
        "name": "performing_doctor",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Quantity",
        "name": "qty",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Item",
        "name": "serviceName",
        "selected": true,
        "hidden": false,
        "order": 2
      },
      {
        "heading": "Service Priority",
        "name": "priority",
        "selected": true,
        "hidden": false,
        "order": 4
      },
      {
        "heading": "Total Amount",
        "name": "total_amount",
        "selected": true,
        "hidden": false,
        "order": 5
      },
      {
        "heading": "Discount",
        "type": "textbox",
        "name": "discountValue",
        "selected": true,
        "typeValue": "decimal_currency",
        "hidden": false,
        "hint": "Enter discount",
        "disable": true,
        "order": 6
      },
      {
        "heading": "Patient Amount",
        "name": "patient_amount",
        "selected": true,
        "hidden": false,
        "order": 6
      },
      {
        "heading": "Payer Amount",
        "name": "payer_amount",
        "selected": true,
        "hidden": false,
        "order": 7
      },
      {
        "heading": "Net Amount",
        "name": "net_amount",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Tax",
        "name": "tax",
        "selected": true,
        "hidden": false,
        "order": 8
      },
      {
        "heading": "Emergency Holiday Charges",
        "name": "emergency_hoiday_charge",
        "selected": true,
        "hidden": false,
        "order": 9
      },
      {
        "heading": "Emergency Holiday Percentage",
        "name": "emergency_hoiday_percentage",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Order Date/Time",
        "name": "order_date_time",
        "type": "date",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "Service Code",
        "name": "service_code",
        "selected": true,
        "hidden": false,
        "order": 10
      },
      {
        "heading": "field.label.standard_code",
        "card_tag": null,
        "order": 12,
        "name": "standard_codes",
        "format": "fn=function(item){ return (item.code_type + ':' + item.code_type_value)}",
        "type": "array"
      },
      {
        "heading": "",
        "type": "multiple_action",
        "setting": true,
        "order": 13,
        "array": [
          {
            "delete": false,
            "cancel": true,
            "toolTip": "Cancel Service",
            "cancel-icon": "fa fa-times",
            "edit": false
          },
          {
            "delete": false,
            "edit": true,
            "toolTip": "View Detail",
            "edit-icon": "fa fa-info",
            "condition": "item['serviceType_code'] == 'phc' && !item['miscllaneous']"
          }
        ]
      }
    ];
    return fields;
  }

  checkPerformByAllowed(serviceItem: any, doctor: any): { allowed: boolean; message?: string } {
    const allowedDoctors = serviceItem?.performingDoctorList || serviceItem?.performing_doctor || [];
    const allowedSpecialities = serviceItem?.performingSpecialityList || serviceItem?.performing_speciality || [];

    if (allowedDoctors.length === 0 && allowedSpecialities.length === 0) {
      return { allowed: true }; // nothing configured -> unrestricted, per requirement
    }
    if (allowedDoctors.length > 0) {
      const doctorMatch = allowedDoctors.some(d => String(d.practitioner_id || d.id) === String(doctor?.practitioner_id || doctor?.id));
      return doctorMatch ? { allowed: true } : { allowed: false, message: "Selected doctor is not permitted to perform this service." };
    }
    const specialityMatch = allowedSpecialities.some(s => String(s.id) === String(doctor?.speciality_id));
    return specialityMatch ? { allowed: true } : { allowed: false, message: "Doctor's speciality is not permitted for this service." };
  }

  setArguments(args) {
    if (Object.keys(args).length > 0) {
      var result = Object.keys(args).map(function (key) {
        return [key + ':' + args[key]];
      });

      var merged = [].concat.apply([], result);
      return merged.join()
    }
  }

  getResourceConfigForpriority() {
    return new Promise((resolve) => {
      this.baseService.get('GET_CONFIG', 'module_code:appointment,config_code:appointment_0008', 'facility_config_mapping', 'facility-management').subscribe(
        result => {
          if (result.errCode == 0) {
            result = result.resource[0];
            if (result.config_value == "no") {
              resolve(false)
            } else {
              resolve(true)
            }
          } else {
            result(false)
          }
        })
    })
  }

  geEmrType(uhId, facility_id, department_id, callback) {
    let data = {
      args: "uhId:" + uhId + ",facility_id:" + facility_id + ",department_id:" + department_id
    }

    this.baseService.getData(data, "", "emr_type_department_mapping_master", "facility-management", "GET_PATIENT_BY_IVF_NO_EMR_TYPE").subscribe(
      res => {
        if (res.errCode == 0 && res.resource.length > 0) {
          callback(res);
        } else {
          callback(false)
        }
      }
    )
  }

  openEmrTypePopup() {
    const obj = {
      resource: 'appointment_emr_type_consulation',
      action: 'ADD',
      layout_type: 'simple',
      getdata: true,
      customButton: {
        Add: [
          {
            label: 'Submit'
          }
        ]
      }
    };
    return this.smartModalService.open(PopupFormComponent, obj, 'Consultation Type', ModalSize.Sm);
  }


  EmrTypeConsultation(appointment: any): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        const uhId = appointment?.patientData?.uhId ?? appointment.uhId;
        const facilityId = appointment?.patientData?.facility_id ?? appointment.facility_id;
        const subDepartment_id = appointment?.servicesArray?.[0]?.subDepartment_id ?? appointment.subDepartment_id;

        if (!uhId || !facilityId || !subDepartment_id) {
          console.warn('Missing required data for EMR check:', { uhId, facilityId, subDepartment_id });
          resolve(null); // Return null if required data is missing
          return;
        }

        const args = `uhId:${uhId},facility_id:${facilityId},subDepartment_id:${subDepartment_id}`;
        const data = { args };

        this.baseService.getData(data, '', 'emr_type_department_mapping_master', 'facility-management', 'GET_PATIENT_BY_IVF_NO_EMR_TYPE').subscribe(res => {
          if (res?.errCode === 0 && res?.resource?.length > 0) {
            resolve(res);
          } else if (res?.errCode === -1) {
            this.alertsService.error(res.message || 'Unexpected error occurred');
            resolve(false);
          } else {
            resolve(null); // API returned no valid result
          }
        },
          err => {
            console.error('HTTP error while fetching EMR type:', err);
            reject(err); // Network or HTTP error
          }
        );

      } catch (err) {
        console.error('Unexpected error in EmrTypeConsultation:', err);
        reject(err);
      }
    });
  }
  getEmrTypeConfig(): Promise<boolean> {
    return new Promise((resolve) => {
      this.baseService.get('GET_CONFIG', 'module_code:appointment,config_code:enable_art_workflow', 'facility_config_mapping', 'facility-management').subscribe(
        result => {
          if (result?.errCode === 0 && result?.resource?.length) {
            resolve(result.resource[0].config_value !== 'no');
          } else {
            resolve(false);
          }
        },
        error => {
          console.error('Config fetch error:', error);
          resolve(false);
        }
      );
    });
  }

  getConsultationInstructions() {  // get consultation Instruction resource  
    return new Promise((resolve) => {
      this.baseService.getResourceDef('consultation_instruction', (data) => {
        resolve(data);
      })
    });
  }

}
